module.exports = __webpack_public_path__ + "static/img/pic_rjyf_xmal05.e3d7038f.png";